<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-body tab2-card">
          <form [formGroup]="suppliersLicenceForm" class="needs-validation" novalidate>
            <div class="form-group row">
              <label>{{cui}}</label>
              <div class="col-xl-3 col-md-3">
                <input class="form-control" formControlName="cui" type="text" />
              </div>
              <label>{{supplierName}}</label>
              <div class="col-xl-3 col-md-3">
                <input class="form-control" type="text" formControlName="supplierName" />
              </div>
            </div>

            <div class="form-group row">
              <label class="bold">{{decision}}</label>
            </div>

            <div *ngIf="licence.status !== 'ACTIV'; else suspended" class="form-group row">
              <label>Marcheaza ca</label>
              <div class="col">
                <label class="d-block">
                  <input class="radio_animated" id="i-1" formControlName="licenceStatus" value="SUSPENDAT" type="radio"
                    reqired>
                  Licenta suspendata
                </label>
                <label class="d-block">
                  <input class="radio_animated" id="i-2" formControlName="licenceStatus" value="ANULAT" type="radio"
                    required>
                  Licenta retrasa
                </label>
              </div>
            </div>

            <ng-template #suspended>
              <div class="form-group row">
                <div class="space">
                  <label style="margin-right: 10px;">Ridicare suspendare licenta furnizor</label>
                  <input class="checkbox_animated" [checked]="shouldLiftLicenceRestriction"
                    [disabled]="actionType !== 'ridicaSuspendare'" type="checkbox" (change)="setActive()" />
                </div>
              </div>
            </ng-template>

            <div class="form-group row">
              <label>Data de inceput</label>
              <div class="col-xl-3 col-md-3">
                <input [min]="tomorrow | date:'yyyy-MM-dd'" class="form-control" type="date"
                  formControlName="statusChangeDate" onkeydown="return false" required />
              </div>
            </div>

            <div class="form-group row">
              <label>Motiv</label>
              <div class="col-xl-3 col-md-3">
                <textarea required formControlName="reason" class="form-control" rows="4"></textarea>
              </div>
            </div>
          </form>

          <div class="card-footer row pull-right">
            <button type="button" class="btn btn-primary button-margin" (click)="onCancel()">
              Renunta
            </button>
            <button type="button" class="btn btn-primary button-margin" (click)="onSubmit()">
              {{saveButtonText}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>